import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.fixed.js";
import { defineComponent as _defineComponent } from 'vue';
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import AreaView from '@/common/components/AreaView.vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    scene: Number,
    fixed: {
      type: Boolean,
      "default": true
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["Activity", ["activity-".concat(__props.scene)]])
      }, [__props.scene === 1 ? (_openBlock(), _createBlock(AreaView, {
        key: 0,
        fixed: __props.fixed
      }, {
        header: _withCtx(function (attrs) {
          return [_renderSlot(_ctx.$slots, "header", _normalizeProps(_guardReactiveProps(attrs)))];
        }),
        overlay: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "overlay")];
        }),
        "default": _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        }),
        _: 3
      }, 8, ["fixed"])) : _renderSlot(_ctx.$slots, "default", {
        key: 1
      })], 2);
    };
  }
});